import { NAV_BAR_TYPES } from '@constants/actionTypes/navBarActionTypes';

export const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case NAV_BAR_TYPES.SET_NAV_BAR_DATA: {
            return action.navBarData;
        }
        default:
            return state;

    }
};